import { render, staticRenderFns } from "./WootReports.vue?vue&type=template&id=3f115d87&scoped=true&"
import script from "./WootReports.vue?vue&type=script&lang=js&"
export * from "./WootReports.vue?vue&type=script&lang=js&"
import style0 from "./WootReports.vue?vue&type=style&index=0&id=3f115d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f115d87",
  null
  
)

export default component.exports